import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Layout from "../../components/Layout"
import Seo from "../../components/Seo"
import { Link } from "gatsby"
import { BiArrowBack } from "react-icons/bi"
const Refund_Alerts_and_Customer_Comments = () => {
  return (
    <Layout>
      <Seo
        title="Customer Returns and Refunds"
        description="Notification for Amazon customer returns and the reason for the return using uservoice"
      />
      <Container fluid className="px-0">
        <div className="text-center " style={{ position: "relative" }}>
          <Styledh1 className="display-4">
            Customer Returns and Refunds
          </Styledh1>
          <StaticImage
            className="mt-2"
            src="../../assets/images/featuresbg.jpg"
            alt="Amazon FBA App Features"
            placeholder="tracedSVG"
            layout="fullWidth"
            aspectRatio={6 / 1}
            style={{ zIndex: "-1" }}
          ></StaticImage>
        </div>
        <Container className="p-5">
          <Row className="mx-auto">
            <Col>
              <Row className="text-center">
                <Col sm={6} className="pb-5">
                  <StaticImage
                    src="../../assets/images/azszero-refunds1-01.png"
                    alt="Actions for Split Testing"
                    placeholder="tracedSVG"
                    layout="constrained"
                    //aspectRatio={1 / 1}
                    height="600"
                  ></StaticImage>
                </Col>{" "}
                <Col sm={6} className="pb-5">
                  <StaticImage
                    src="../../assets/images/azszero-refunds2-01.png"
                    alt="Amazon Refunds"
                    placeholder="tracedSVG"
                    layout="constrained"
                    //aspectRatio={1 / 1}
                    height="600"
                  ></StaticImage>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={8} className="pb-5">
                  <ul>
                    <li>
                      The system keeps track of the refund rate on each item,
                      when the rate becomes high for a possible suspension, you
                      will get notified to see what actions needed to be taken
                      to avoid any suspension.
                    </li>
                    <li>
                      each item return has multiple reasons, but azszero is
                      smart enough to see the main reason that could lead to a
                      possible suspension.
                    </li>
                    <li>
                      Each item that has returns will show how many customers
                      wrote the return reason, you can refer to that to
                      understand what went wrong.
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
          ``{" "}
          <Row>
            <Col>
              <Link to="/Amazon_FBA_Seller_App_Features">
                <BiArrowBack />
                &nbsp;&nbsp;Back to Features Page
              </Link>{" "}
            </Col>
          </Row>
        </Container>
      </Container>
    </Layout>
  )
}
const Styledh1 = styled.h1`
  padding: 30px;
  color: slategray;
  margin-bottom: -50px;
  z-index: 10;
  font-weight: 700;
`
export default Refund_Alerts_and_Customer_Comments
